import React, { useState, useEffect } from 'react';
import {
  Box,
  Button,
  FormControl,
  FormLabel,
  RadioGroup,
  FormControlLabel,
  Radio,
  Alert,
  CircularProgress
} from '@mui/material';

const CashierDisplaySettings = () => {
  const [cartItemSize, setCartItemSize] = useState('compact');
  const [loading, setLoading] = useState(false);
  const [message, setMessage] = useState(null);

  useEffect(() => {
    fetchSettings();
  }, []);

  const fetchSettings = async () => {
    try {
      const res = await fetch('/api/settings/cashier-display');
      if (res.ok) {
        const data = await res.json();
        if (data.cartItemSize) {
          setCartItemSize(data.cartItemSize);
        }
      }
    } catch (err) {
      console.error('Failed to fetch cashier display settings:', err);
    }
  };

  const handleSave = async () => {
    setLoading(true);
    setMessage(null);
    try {
      const res = await fetch('/api/settings/cashier-display', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ cartItemSize }),
      });
      if (res.ok) {
        setMessage({ type: 'success', text: 'Cashier display settings saved!' });
        // Trigger a custom event to notify Cashier component
        window.dispatchEvent(new CustomEvent('cashierDisplaySettingsChanged', { 
          detail: { cartItemSize } 
        }));
      } else {
        setMessage({ type: 'error', text: 'Failed to save settings' });
      }
    } catch (err) {
      setMessage({ type: 'error', text: 'Error saving settings' });
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box>
      <FormControl component="fieldset" fullWidth>
        <FormLabel component="legend" sx={{ mb: 2, fontWeight: 600 }}>
          Cart Item Display Size
        </FormLabel>
        <RadioGroup
          value={cartItemSize}
          onChange={(e) => setCartItemSize(e.target.value)}
        >
          <FormControlLabel 
            value="compact" 
            control={<Radio />} 
            label="Compact - Smallest size, fit more items (single line)" 
          />
          <FormControlLabel 
            value="comfortable" 
            control={<Radio />} 
            label="Comfortable - Medium size, balanced view" 
          />
          <FormControlLabel 
            value="spacious" 
            control={<Radio />} 
            label="Spacious - Largest size, easier to read" 
          />
        </RadioGroup>
      </FormControl>

      {message && (
        <Alert severity={message.type} sx={{ mt: 2 }}>
          {message.text}
        </Alert>
      )}

      <Button
        variant="contained"
        onClick={handleSave}
        disabled={loading}
        sx={{ mt: 2 }}
      >
        {loading ? <CircularProgress size={24} /> : 'Save Display Settings'}
      </Button>
    </Box>
  );
};

export default CashierDisplaySettings;
